// extracted by mini-css-extract-plugin
export default {"slider":"Carousels_slider__JN-th","item":"Carousels_item__5FSy-","mask":"Carousels_mask__b34tn"};